import React, { useCallback } from 'react'
import { CommonCard } from '../../Card/CommonCard'
import { MCP_KNOWLEDGEBASE_URL } from '../../../views/OAuth2App/constants'
import './HowToUseAppsCard.scss'

export const HowToUseAppsCard: React.FC = () => {
  const handleLearnMore = useCallback(() => {
    window.open(MCP_KNOWLEDGEBASE_URL, '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <CommonCard
      className='how-to-use-apps-card'
      onCardClick={handleLearnMore}
      header={
        <div className='how-to-use-apps-card__icon d-flex align-items-center justify-content-center rounded-1 zocks-bg-color-gray-900'>
          <i className='bi bi-mortarboard-fill text-white' />
        </div>
      }
      description={
        <div className='d-flex flex-column gap-1'>
          <span className='app-card-name-label'>
            Your complete guide
            <br />
            to MCP apps
          </span>
          <div className='label-medium zocks-text-gray-900 mt-3'>
            Step-by-step help, use cases, and best practices for using Zocks inside Claude and other AI tools.
          </div>
        </div>
      }
      state={null}
      footer={<span className='fw-bold text-decoration-underline zocks-text-gray-900'>Browse the knowledge base</span>}
    />
  )
}
